import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  loadingContainer: {
    position: 'fixed',
    width: '100%',
    top: '50px',
    paddingTop: '50%',
    height: '100%',
    backgroundColor: '#fff',
    zIndex: '1000',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '50%',
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: '20%',
    },
    [theme.breakpoints.only('lg')]: {
      position: 'fixed',
      width: '100%',
      top: '50px',
      paddingTop: '50%',
      height: '100%',
      backgroundColor: '#fff',
      zIndex: '1000',
      left: '0px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      paddingTop: '40%',
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: '30%',
    },
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
});

class Loader extends React.Component {
  render() {
    const { classes, loadingText } = this.props;
    return (
      <div className={classes.loadingContainer}>
        <div className={classes.centered}>
          <CircularProgress color="secondary" />
          <br />
          <br />
          <Typography variant="subtitle1">{loadingText}</Typography>
        </div>
      </div>
    );
  }
}

Loader.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Loader);
